import axios from 'axios'

/**
 * Directus is the identity provider — the console logs operators in against it
 * and hands the returned token to the ludus engine, which validates it back
 * with Directus (see the engine's auth middleware). No separate user store.
 *
 * `VITE_DIRECTUS_URL` is the PUBLIC Directus origin (baked at build time). Its
 * CORS must allow the console origin (Directus `CORS_ORIGIN`).
 */

const DIRECTUS_URL = (import.meta.env.VITE_DIRECTUS_URL ?? 'http://localhost:8155').replace(
  /\/$/,
  '',
)

export class LoginError extends Error {
  constructor(readonly kind: 'invalid_credentials' | 'network' | 'unknown') {
    super(kind)
    this.name = 'LoginError'
  }
}

/** Exchange email + password for a Directus access token. */
export async function directusLogin(email: string, password: string): Promise<string> {
  try {
    const { data } = await axios.post(`${DIRECTUS_URL}/auth/login`, { email, password })
    const token = data?.data?.access_token
    if (typeof token !== 'string' || !token) throw new LoginError('unknown')
    return token
  } catch (err) {
    if (err instanceof LoginError) throw err
    const status = (err as { response?: { status?: number } }).response?.status
    if (status === 401) throw new LoginError('invalid_credentials')
    if (status === undefined) throw new LoginError('network')
    throw new LoginError('unknown')
  }
}
